export class AttachmentType {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default AttachmentType;